module.exports = __webpack_public_path__ + "static/img/zy1.47173c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/zy1.jpg
// module id = bEhM
// module chunks = 0